import {
  SRG_LOGIN_CHECK_SESSION,
  SRG_LOGIN_LOGGED_IN,
  SRG_LOGIN_LOGGED_OUT,
} from "@Constants/SrgLoginEvents";
import { triggerEvent } from "@Utils/event";
import { useCallback, useEffect } from "react";

export type LoginUser = {
  userId: string;
  preferredUsername?: string;
  idToken: string;
  email: string;
};

type UseLoginOptions = {
  onLogin?: (user: LoginUser) => void;
  onLogout?: () => void;
};

export const useLogin = ({ onLogin, onLogout }: UseLoginOptions) => {
  const handleLogin = useCallback(
    (event: Event) => {
      const data = (event as CustomEvent).detail;
      const { user } = data;

      if (!user) {
        return;
      }

      const { profile } = user;
      const {
        sub: userId,
        preferred_username: preferredUsername,
        email,
      } = profile;
      const { id_token: idToken } = user;

      const loginUser: LoginUser = {
        userId,
        preferredUsername,
        idToken,
        email,
      };

      onLogin?.(loginUser);
    },
    [onLogin],
  );

  const handleLogout = useCallback(() => {
    onLogout?.();
  }, [onLogout]);

  useEffect(() => {
    window.addEventListener(SRG_LOGIN_LOGGED_IN, handleLogin);
    window.addEventListener(SRG_LOGIN_LOGGED_OUT, handleLogout);
    triggerEvent(SRG_LOGIN_CHECK_SESSION);

    return () => {
      window.removeEventListener(SRG_LOGIN_LOGGED_IN, handleLogin);
      window.removeEventListener(SRG_LOGIN_LOGGED_OUT, handleLogout);
    };
  }, [handleLogin, handleLogout]);
};
